var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: {
        invisible: _vm.times[_vm.time] === false,
        muted: _vm.times[_vm.time] === undefined
      },
      attrs: {
        "data-tooltip": _vm._f("ifElse")(
          _vm._f("defined")(_vm.times[_vm.time]),
          _vm.i18n.time[_vm.time],
          _vm.i18n.time.unknown
        )
      }
    },
    [_c("span", { staticClass: "time-icon", class: [_vm.time] })]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d5a2c70", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d5a2c70","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./src/components/beverages/time-icon/time-icon.html
// module id = 157
// module chunks = 0